import { render, staticRenderFns } from "./newDevLog.vue?vue&type=template&id=691f7f9e&scoped=true"
import script from "./newDevLog.vue?vue&type=script&lang=js"
export * from "./newDevLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691f7f9e",
  null
  
)

export default component.exports